import { useContext, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import KYouthSectionTitle from "../sectionTitle/KYouthSectionTitle";

const accordionItems = [
  {
    id: 1,
    title: "What does it take become an author?",
    body: "Learning management system, combines a wide range of features to present a class setting without having the students come into a physical classroom. It all depends on the WordPress LMS plugin you go with, but in general.",
  },
  {
    id: 2,
    title: "How to Change my Password easily?",
    body: "Learning management system, combines a wide range of features to present a class setting without having the students come into a physical classroom. It all depends on the WordPress LMS plugin you go with, but in general.",
  },
  {
    id: 3,
    title: "How to Change my Plan using PayPal?",
    body: "Learning management system, combines a wide range of features to present a class setting without having the students come into a physical classroom. It all depends on the WordPress LMS plugin you go with, but in general.",
  },
  {
    id: 4,
    title: "How long it take to create a video course?",
    body: "Learning management system, combines a wide range of features to present a class setting without having the students come into a physical classroom. It all depends on the WordPress LMS plugin you go with, but in general.",
  },
];

const CustomToggle = ({ children, eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <button
      type="button"
      onClick={decoratedOnClick}
      aria-expanded={isCurrentEventKey ? true : false}
      className="edu-accordion-button"
    >
      {children}
    </button>
  );
};

const KYouthProgramme3 = () => {
  const [activeId, setActiveId] = useState("0");
  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  return (
    <div className="edu-accordion-area eduvibe-home-three-accordion accordion-shape-1">
      <div className="container eduvibe-animated-shape">
        <div className="row g-5">
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="workshop-inner">
              <KYouthSectionTitle
                classes="text-white"
                slogan="INTAKE COMMENCES IN APRIL 2026"
                title={
                  <h3
                    className="title"
                    style={{
                      fontWeight: 800,
                      // color: "var(--color-contrast-dark)",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--color-khazanah)",
                      }}
                    >
                      K-YOUTH{" "}
                    </span>
                    DEVELOPMENT PROGRAMME 2026
                  </h3>
                }
              />

              <ScrollAnimation
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                animateOnce={true}
              >
                <div
                  className="color-white"
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    backgroundColor: "var(--color-contrast)",
                    padding: "4px 12px",
                    marginTop: 20,
                    width: "fit-content",
                  }}
                >
                  BECOME AN AI PROFESSIONAL IN DIGITAL & TECHNOLOGY ROLES
                </div>

                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOut="fadeInOut"
                  animateOnce={true}
                >
                  <p
                    className="description line-before-white mt--30 mb--30"
                    style={{
                      fontWeight: 700,
                      fontSize: 20,
                      // color: "var(--color-contrast-alt)",
                    }}
                  >
                    Monthly salary RM 2,000 (Diploma) and RM 2,300 (Degree), for
                    4 months including EPF and SOCSO benefits LIMITED POSITION
                    AVAILABLE.
                  </p>
                </ScrollAnimation>

                <div
                  className="color-white"
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    backgroundColor: "var(--color-contrast)",
                    width: "fit-content",
                    padding: "4px 12px",
                  }}
                >
                  REQUIREMENTS
                </div>
                <ul>
                  <li style={{ color: "var(--color-white)" }}>
                    Malaysian citizens below 30 years old.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Unemployed for more than 1 month.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Have NOT participated in any similar programme. (e.g.
                    Protégé, MySTEP, K-Youth 2023-2025)
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Malaysian graduates with Diploma or Degree qualifications
                    from recognised institutions.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Possess strong interest towards being employed in Digital &
                    Technology roles with AI upskilling opportunities.
                  </li>
                </ul>

                <div
                  className="color-white"
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    backgroundColor: "var(--color-contrast)",
                    width: "fit-content",
                    padding: "4px 12px",
                  }}
                >
                  BENEFITS
                </div>

                <ul>
                  <li style={{ color: "var(--color-white)" }}>
                    Professional apprenticeship with reputable industry
                    partners.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Monthly allowance of RM 2,000 (Diploma) and RM 2,300
                    (Degree), inclusive of EPF & SOCSO.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    4-month On-the-Job Training (OJT) placement with formal
                    certification.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Industry-recognised, future-ready AI skills with integrated
                    career readiness modules.
                  </li>
                  <li style={{ color: "var(--color-white)" }}>
                    Hands-on teaching practicum and real-world applied AI
                    project experience.
                  </li>
                </ul>
              </ScrollAnimation>

              <ScrollAnimation
                animateIn="fadeInUp"
                animateOut="fadeInOut"
                className="read-more-btn"
                animateOnce={true}
                // style={{ paddingTop: "3rem" }}
              >
                <a
                  className="edu-btn btn-purple"
                  href="https://kyouth.pepperlabs.my"
                  target="_blank"
                >
                  APPLY NOW
                  <i className="icon-arrow-right-line-right"></i>
                </a>
              </ScrollAnimation>
            </div>
          </div>
          <div className="col-lg-6 gallery-wrapper">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="thumbnail">
                  <img
                    className="radius-small w-100"
                    style={{
                      height: 450,
                      objectFit: "cover",
                      objectPosition: "57% 50%",
                    }}
                    src={`${process.env.PUBLIC_URL}/k-youth/assets/intake-1.jpeg`}
                    alt="About Thumb 1"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 mt--35 mt_sm--15">
                <div className="thumbnail">
                  <img
                    className="radius-small w-100"
                    src={`${process.env.PUBLIC_URL}/k-youth/assets/intake-2.jpeg`}
                    alt="About Thumb 2"
                  />
                </div>
                <div className="thumbnail mt--15">
                  <img
                    className="radius-small w-100"
                    src={`${process.env.PUBLIC_URL}/k-youth/assets/intake-3.jpeg`}
                    alt="About Thumb 3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
          <div className="shape-image shape-image-4">
            <img
              src="/k-youth/images/shapes/shape-14-02.png"
              alt="Shape Thumb"
            />
          </div>
          {/* <div className="shape-image shape-image-2">
            <img src="/k-youth/images/shapes/shape-04-05.png" alt="Shape Thumb" />
          </div> */}
          <div className="shape-image shape-image-3">
            <img
              src="/k-youth/images/shapes/shape-13-02.png"
              alt="Shape Thumb"
            />
          </div>
          {/* <div className="shape shape-1">
            <span className="shape-dot"></span> 
          </div> */}
          {/* <div className="shape-image shape-image-2">
            <img src="/k-youth/images/shapes/shape-11-04.png" alt="Shape Thumb" />
          </div> */}
          <div className="shape-image shape-image-3">
            <img
              src="/k-youth/images/shapes/shape-25-01.png"
              alt="Shape Thumb"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYouthProgramme3;

{
  /* <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/k-youth/images/shapes/shape-09-01.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/k-youth/images/shapes/shape-04-05.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-3">
                            <img src="/k-youth/images/shapes/shape-13-02.png" alt="Shape Thumb" />
                        </div>
                    </div> */
}
